import React from 'react';
import { useForm, Link } from '@inertiajs/react';
import AuthLayout from '../layouts/AuthLayout';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';

export default function SignUp({ csrf_token }) {
  const { data, setData, post, processing, errors } = useForm({
    email: '',
    password: '',
    password_confirmation: '',
    authenticity_token: csrf_token
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    post('/sign_up');
  };

  return (
    <AuthLayout 
      title="Create your account" 
      description="Sign up to start finding the perfect community"
    >
      <form className="space-y-6" onSubmit={handleSubmit}>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email address</Label>
            <Input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              required
              placeholder="name@example.com"
              value={data.email}
              onChange={e => setData('email', e.target.value)}
            />
            {errors.email && <p className="text-sm text-destructive mt-1">{errors.email}</p>}
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              name="password"
              type="password"
              autoComplete="new-password"
              required
              placeholder="••••••••"
              value={data.password}
              onChange={e => setData('password', e.target.value)}
            />
            {errors.password && <p className="text-sm text-destructive mt-1">{errors.password}</p>}
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="password_confirmation">Confirm Password</Label>
            <Input
              id="password_confirmation"
              name="password_confirmation"
              type="password"
              autoComplete="new-password"
              required
              placeholder="••••••••"
              value={data.password_confirmation}
              onChange={e => setData('password_confirmation', e.target.value)}
            />
            {errors.password_confirmation && (
              <p className="text-sm text-destructive mt-1">{errors.password_confirmation}</p>
            )}
          </div>
        </div>

        <Button
          type="submit"
          className="w-full"
          disabled={processing}
        >
          {processing ? 'Creating account...' : 'Sign up'}
        </Button>

        <div className="text-center mt-6">
          <p className="text-sm text-muted-foreground">
            Already have an account?{' '}
            <Link href="/sign_in" className="font-medium text-primary hover:underline">
              Sign in
            </Link>
          </p>
        </div>
      </form>
    </AuthLayout>
  );
}
